import { useLocation, useNavigate } from 'react-router-dom'
import { Caption1, Heading2, Heading3 } from '@/components/ui/typography'

export const DashboardErrorPage = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const fromLayout = location.state?.layoutId

  const handleBack = () => {
    navigate(`/dashboard${fromLayout ? `?layout=${fromLayout}` : ''}`, {
      replace: true,
    })
  }

  return (
    <div className='flex h-screen flex-col bg-gray-50'>
      <div className='flex flex-shrink-0 items-center justify-between border-b border-gray-200 px-6 py-4 shadow-sm'>
        <Heading2 bold>IB Dashboard</Heading2>
      </div>

      <div className='flex flex-1 items-center justify-center p-12'>
        <div className='max-w-md w-full rounded-xl border border-red-200 bg-red-50 p-8 shadow-sm'>
          <div className='mb-4 text-4xl'>⚠️</div>

          <Heading3 bold className='mb-2 text-red-900'>
            Failed to load dashboard
          </Heading3>

          <Caption1 className='mb-6 text-red-700'>
            Something went wrong while loading dashboard data. Please try again or go back.
          </Caption1>

          <button
            onClick={handleBack}
            className='w-full rounded-lg bg-[var(--sidebar-primary)] px-6 py-3 text-sm font-semibold text-white transition-all hover:opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-[var(--ring)]'
          >
            Back to Dashboard
          </button>
        </div>
      </div>
    </div>
  )
}
